import type { NavigateFunction } from 'react-router-dom';

export function scrollToSection(sectionId: string): boolean {
  const el = document.getElementById(sectionId);
  if (!el) return false;
  el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  window.history.replaceState(null, '', `#${sectionId}`);
  return true;
}

export function goToSection(navigate: NavigateFunction, sectionId: string, homePath = '/') {
  if (window.location.pathname === homePath) {
    scrollToSection(sectionId);
    return;
  }
  navigate(`${homePath}#${sectionId}`);
}
